import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3d3a97fe"
import script from "@/scripts/emailNotification/emailNotification.js?vue&type=script&lang=js&external"
export * from "@/scripts/emailNotification/emailNotification.js?vue&type=script&lang=js&external"
import style0 from "./index.vue?vue&type=style&index=0&id=3d3a97fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports